// extracted by mini-css-extract-plugin
module.exports = {"symbol":"symbol___3mpjZ"};